import { gql } from "@apollo/client";

import IOperation from "api/IOperation";
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import { ClearCartMutation as ClearCartMutationType, ClearCartMutationVariables } from "gql/types/mutations/ClearCartMutation";

const text = gql`mutation ClearCartMutation($clearCartInput: MutationClearCartInput!) {
	clearCart(clearCartInput: $clearCartInput) {
		order {
			id
		}
	}
}
`;

const ClearCartMutation: IOperation<ClearCartMutationType, ClearCartMutationVariables> = { text } as any;

export default ClearCartMutation;
